// ヘッダーの色クラス（.-white）をスクロール位置で切り替える
// 条件: スクロール量が #header の高さ以上になったら .-white を付与。
// 上に戻ったら（高さ未満）.-white を外す。

(function () {
  "use strict";

  // 依存するDOMが揃ってから実行
  const onReady = (fn) => {
    if (
      document.readyState === "complete" ||
      document.readyState === "interactive"
    ) {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    }
  };

  onReady(() => {
    const header = document.getElementById("header");
    if (!header) return;

    const WHITE_CLASS = "-white";
    const root = document.documentElement;

    // 現在のヘッダー高を返す（小数切り捨てで安定化）
    const getHeaderHeight = () =>
      Math.floor(header.getBoundingClientRect().height);

    let threshold = getHeaderHeight();
    let lastY = -1;
    let ticking = false;

    const updateClass = (y) => {
      // 閾値以上スクロールなら白クラスを付与、未満なら外す
      const shouldAddWhite = y >= threshold;
      const hasWhite = header.classList.contains(WHITE_CLASS);

      if (shouldAddWhite && !hasWhite) {
        header.classList.add(WHITE_CLASS);
      } else if (!shouldAddWhite && hasWhite) {
        header.classList.remove(WHITE_CLASS);
      }
    };

    const onScroll = () => {
      const y =
        root.scrollTop || window.pageYOffset || document.body.scrollTop || 0;
      if (y === lastY) return;
      lastY = y;
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          updateClass(lastY);
          ticking = false;
        });
      }
    };

    // リサイズやフォントロードで高さが変わる場合に閾値を更新
    const recalcThreshold = () => {
      threshold = getHeaderHeight();
      // 閾値が変わった可能性があるので現状スクロール位置で再適用
      onScroll();
    };

    // 初期状態（ページ最上部では -white を外す）
    header.classList.remove(WHITE_CLASS);
    onScroll();

    // 監視セットアップ
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", recalcThreshold);

    // 画像やWebフォント読み込みで高さが変化する可能性に備える
    window.addEventListener("load", recalcThreshold, { once: true });
  });
})();
